import { Package } from 'lucide-react';

import { NodeShell } from './NodeShell';

import type { StockNodeData } from '@repo/shared-types';

export const StockNode = ({ data, selected }: { data: StockNodeData; selected?: boolean }) => (
  <NodeShell
    type="stock"
    icon={<Package size={16} />}
    label={data.label}
    subtitle={
      data.action
        ? `${data.action === 'search' ? 'Find by' : 'List'} ${data.searchBy ?? 'registration'}`
        : undefined
    }
    selected={selected}
  />
);
